<template lang="pug">
  el-container
    el-header(height="auto")
      el-form(inline label-suffix=":")
        el-form-item(label="城市")
          city-select(v-model="city")
        el-form-item(label="景区" prop="scenicGuid")
          el-select(v-model="scenicGuid" filterable)
            el-option(
              v-for="city in scenicList$"
              :label="city.name"
              :value="city.guid"
              :key="city.guid"
            )
        br
        el-form-item(label="开锁时间")
          el-date-picker(
            v-model="unlockTime"
            type="datetimerange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
          )
        el-form-item(label="关锁时间")
          el-date-picker(
            v-model="lockTime"
            type="datetimerange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
          )
        el-form-item
          el-button(
            type="primary"
            plain
            icon="el-icon-search"
            :disabled="paramsError"
            :loading="searching"
            @click="search"
          ) 搜索
        el-form-item
          el-button(
            type="primary"
            plain
            icon="el-icon-download"
            :disabled="paramsError"
            @click="download"
          ) 导出
    el-main
      grid(
        :remoteMethod="getTableData"
        ref="grid"
        layout="prev, next, jumper"
      )
        -
          var columns = [
            { prop:"mobilePhone", label:"手机号"},
            { prop:"bikeNo", label:"车辆编号"},
            { prop:"startTimeName", label:"开锁时间"},
            { prop:"stopTimeName", label:"关锁时间"},
            { prop:"rideTime", label:"骑行时长(分钟)"},
            { prop:"rideCost", label:"骑行费用(元)"},
            { prop:"rideStatusName", label:"订单状态"},
            { prop:"withdrawCount", label:"订单退款金额"},
            { prop:"outOfSaPenalty", label:"调度费"},
            { prop:"drawbackPenalty", label:"调度费退款金额"},
          ];
        each item in columns
          el-table-column(
            prop=item.prop
            label=item.label
          )
</template>

<script>
import { getOrderList, downloadOrderList } from '@/api/report';
import { getScenicCityList, getScenicList } from '@/api/user';
import grid from '@/components/grid';
import { download } from '@/utils';
import citySelect from '@/components/citySelect';

export default {
  name: 'Order',
  components: {
    grid,
    citySelect,
  },
  data() {
    return {
      city: '',
      searching: false,
      dialogVisible: false,
      lockTime: [],
      unlockTime: [],
      scenicGuid: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() >= new Date();
        }
      }
    };
  },
  computed: {
    paramsError() {
      const lockTime = this.lockTime || [];
      const unlockTime = this.unlockTime || [];
      return !this.city || !this.scenicGuid || (lockTime.length + unlockTime.length === 0);
    }
  },
  mounted() {
  },
  subscriptions() {
    const scenicList$ = this.$watchAsObservable('city')
      .pluck('newValue')
      .do(() => { this.scenicGuid = ''; })
      .filter(x => x)
      .switchMap(cityGuid => getScenicList({ cityGuid }))
      .map(data => data.data)
      .startWith([]);
    return {
      scenicList$
    };
  },
  methods: {
    async getTableData(data) {
      const res = await getOrderList(data);
      return { data: res.data, total: 999999 };
    },
    formatParams() {
      return {
        cityGuid: this.city,
        scenicGuid: this.scenicGuid,
        lockTimeBegin: this.lockTime && this.lockTime[0],
        lockTimeEnd: this.lockTime && this.lockTime[1],
        unlockTimeBegin: this.unlockTime && this.unlockTime[0],
        unlockTimeEnd: this.unlockTime && this.unlockTime[1],
      };
    },
    async download() {
      const res = await downloadOrderList(this.formatParams());
      download(res.data.body);
    },
    async search() {
      this.searching = true;
      await this.$refs.grid.loadData(this.formatParams());
      this.searching = false;
    },
    async getScenicCityList() {
      const res = await getScenicCityList();
      this.scenicCityList = res.data || [];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/order/scenicOrder.vue?468dddda